import React, { useState, useRef, useEffect, useContext } from 'react'
import {
  CButton,
  CCol,
  CFormCheck,
  CFormInput,
  CModal,
  CModalBody,
  CModalFooter,
  CModalHeader,
  CModalTitle,
  CFormText,
  CRow,
} from '@coreui/react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faUpload, faLink } from '@fortawesome/free-solid-svg-icons'
import { useFileChange } from 'src/s3upload/use-file-change'
import ImageCropper from '../cms/imageCroper'
import { uploadToS3 } from 'src/s3upload/upload-file'
import { dispatchAlert } from 'src/Redux/Actions/authAction'
import { isEmpty, raiseToast } from 'src/views/utils/helper'
import { getThumbnail } from '../../utils/helper'
import { AppContext } from '../../context/app'
import Loading from 'react-fullscreen-loading'
import AssetManager from '../AssetManager/AssetManager'
import { GlobalContext } from 'src/views/context/GlobalState'
import useAxios from 'axios-hooks'
import { CONTENT_LIST_API } from 'src/views/utils/urls'
import Compressor from 'compressorjs'

const BannerModal = ({ openModal, onCancel, editData, bannerCallback, updateCallback }) => {
  const { fileName, fileContents, fileType, fileSize, fileDispatch } = useFileChange()
  const { setLoader, loader, setContentModalProps } = useContext(AppContext)
  const { userSessionObj } = useContext(GlobalContext)
  const inputRef = useRef(null)
  const accountId = localStorage.getItem('accountId')
  const [imageCropModal, setImageCropModal] = useState(false)
  const editFlag = !isEmpty(editData)

  const [{ data: contentList, loading: contentListLoading }, contentListCall] = useAxios(
    {
      url: CONTENT_LIST_API,
      method: 'get',
    },
    { manual: true },
  )

  useEffect(() => {
    setLoader(contentListLoading)
  }, [contentListLoading])

  useEffect(() => {
    if (contentList && contentList.success) {
      setContentArray([contentList.data])
    }
  }, [contentList])

  useEffect(() => {
    if (editFlag) {
      setImageUrl(getThumbnail(userSessionObj.session_data.cf_domain_name, editData.image_s3_key))
      setTypeBanner(editData.object_type)
      setImageAssetId(editData.image_asset_id)
      setImageS3key(editData.image_s3_key)
      if (editData.object_type === 'CONTENT') {
        setContentId(editData.object_id)

        contentListCall({
          params: {
            content_id: editData.object_id,
          },
        })
        // setContentArray(contentData.filter((obj) => obj._id === editData.object_id))
      } else {
        setRedirectURL(editData.url)
      }
    }
  }, [editFlag])

  const [imageCropObj, setImageCropObj] = useState({
    src: '',
    crop: {},
    imageName: '',
    imageType: '',
  })

  const [imageUrl, setImageUrl] = useState('')
  const [redirectURL, setRedirectURL] = useState('')

  const [contentId, setContentId] = useState('')
  const [contentArray, setContentArray] = useState([])

  const [showAssetManager, setShowAssetManager] = useState(false)
  const [imageAssetId, setImageAssetId] = useState('')
  const [imageS3key, setImageS3key] = useState('')

  const [typeBanner, setTypeBanner] = useState('CONTENT')
  const [errorData, setErrorData] = useState({})

  const handleImage = (event) => {
    const image = event.target.files[0]
    const imageURL = URL.createObjectURL(image)
    setImageCropObj({
      crop: {
        unit: 'px',
        width: 640,
        height: 360,
        aspect: 16 / 9,
      },
      src: imageURL,
      imageName: image.name,
      imageType: image.type,
    })
    setImageCropModal(true)
  }
  const validateInfo = () => {
    let isFormValid = true
    let temp = {}

    if (!imageUrl) {
      isFormValid = false
      temp.imageFileObj = 'UploadContent Image!'
    }
    if (typeBanner === 'CONTENT' && !contentId) {
      isFormValid = false
      temp.contentId = 'Select Content!'
    }
    if (typeBanner === 'EXTERNAL_URL' && !redirectURL) {
      isFormValid = false
      temp.redirectURL = 'Enter URL!'
    }

    setErrorData({ ...temp })
    return isFormValid
  }
  const handleCallback = async (imageUrl, blob) => {
    new Compressor(blob, {
      quality: 0.8,
      success: (compressedResult) => {
        // compressedResult has the compressed file.
        fileDispatch({
          type: 'FILE_CHANGE_SUCCESS',
          fileName: compressedResult.name,
          fileSize: compressedResult.size,
          fileType: compressedResult.type,
          fileContents: compressedResult,
        })

        setImageUrl(window.URL.createObjectURL(compressedResult))
        setImageCropObj({})
      },
      error: (err) => {
        console.log(err.message)
        raiseToast('error', 'Try Again!')
        setImageCropObj({})
      },
    })
  }

  const handleImageUpload = async () => {
    setLoader(true)
    try {
      if (fileType && fileContents) {
        let tempName = fileName.replace(/ /g, '_')
        let data = {
          customer_id: accountId,
          upload_type: 'FROM_DEVICE',
          assets: [
            {
              file_name: tempName,
              file_metadata: {
                file_size: fileSize,
                file_type: fileType,
              },
            },
          ],
        }
        const status = await uploadToS3({ fileContents, data, fileType: 'image' })
        if (status?.success) {
          setImageAssetId(status.assetId)
          setImageS3key(status.s3Key)
          setLoader(false)
          return status
        }
      }
    } catch (err) {
      console.log('err', err)
      dispatchAlert('danger', `Error`, `${err}`, true)
    }
    setLoader(false)
    return false
  }

  const checkImageUpload = async () => {
    if (
      getThumbnail(userSessionObj.session_data.cf_domain_name, editData.image_s3_key) === imageUrl
    )
      return

    await handleImageUpload()
  }

  const handleSubmit = async () => {
    if (!validateInfo()) return

    if (imageS3key && imageAssetId) {
      let bannerObj = {
        image_s3_key: imageS3key,
        image_asset_id: imageAssetId,
        object_type: typeBanner,
      }

      typeBanner === 'CONTENT'
        ? (bannerObj[`object_id`] = contentId)
        : (bannerObj[`url`] = redirectURL)

      editFlag ? updateCallback(bannerObj) : bannerCallback(bannerObj)
    }
  }

  const onBtnClick = () => {
    inputRef.current.click()
  }
  const handleAssetSelect = (info) => {
    setImageUrl(getThumbnail(userSessionObj.session_data.cf_domain_name, info.s3_key))
    setImageAssetId(info.asset_id)
    setImageS3key(info.s3_key)
  }

  const openContentModal = () => {
    setContentModalProps({
      type: 'single',
      mappedContentId: contentId,
      mappedContentArray: contentArray,
      selectCallback: (contentId, contents) => {
        setContentId(contentId)
        setContentArray(contents)
      },
    })
  }
  return (
    <>
      <CModal size="xl" visible={openModal} alignment="center">
        <Loading loading={loader} background={'rgba(60, 60, 60, 0.6)'} loaderColor="#efefef" />
        <CModalHeader className="px-5 py-4">
          <CModalTitle>
            <p className="h4">{editFlag ? `Edit` : `Create New`} Banner</p>
          </CModalTitle>
        </CModalHeader>
        <CModalBody className="px-5 py-4">
          <CRow>
            <CCol>
              <p className="h5">Step 1 : Banner Image*</p>
            </CCol>
          </CRow>
          <CRow className="mt-1 justify-content-between">
            <CCol className="d-flex flex-column justify-content-center banner-col" lg="6">
              <div className="d-flex">
                <CButton
                  color="info"
                  className="text-white font-weight-bold"
                  shape="rounded-pill"
                  onClick={onBtnClick}
                >
                  <FontAwesomeIcon icon={faUpload} className="mx-2" />
                  Upload Image
                </CButton>
                <div style={{ borderRight: '1px solid gray' }} className="mx-3" />
                <CButton
                  color="info"
                  className="text-white font-weight-bold"
                  shape="rounded-pill"
                  onClick={() => setShowAssetManager(true)}
                >
                  <FontAwesomeIcon icon={faUpload} className="mx-2" />
                  Choose Image
                </CButton>
              </div>
              <CFormText className="mt-4">
                Image format should be in .jpeg or . png. with maximum size 1200x675 mm.
              </CFormText>
            </CCol>
            <CCol lg="5">
              <div
                style={{
                  border: '1px solid #707070',
                  height: '8.5rem',
                  width: '15.11rem',
                }}
                className="d-flex justify-content-center"
              >
                {!imageUrl ? (
                  <CFormText className="preview-div-text">Preview</CFormText>
                ) : (
                  <div className="banner-image-div">
                    <img src={imageUrl || ''} alt={'banner'} onLoad={checkImageUpload} />
                  </div>
                )}
                <input
                  type="file"
                  accept="image/*"
                  hidden
                  name="logo"
                  id="logo"
                  ref={inputRef}
                  onChange={(e) => handleImage(e)}
                />
              </div>
            </CCol>
            <div className="message-text error-message">
              <p>{errorData.imageFileObj}</p>
            </div>
          </CRow>
          <CRow className="mt-4">
            <CCol>
              <p className="h5">Step 2 : Connect the Banner*</p>
            </CCol>
          </CRow>
          <CRow className="mt-3">
            <CCol lg="4">
              <CFormCheck
                type="radio"
                name="flexRadioDefault"
                label="Link Banner with Content"
                checked={typeBanner === 'CONTENT'}
                onClick={() => setTypeBanner('CONTENT')}
              />
            </CCol>
            <CCol lg="4">
              <CButton
                color="info"
                className="text-white font-weight-bold"
                shape="rounded-pill"
                onClick={() => openContentModal()}
              >
                <FontAwesomeIcon icon={faLink} className="mx-2" />
                Select Content
              </CButton>
              <div className="message-text error-message">
                <p>{errorData.contentId}</p>
              </div>
            </CCol>
            <CCol lg="4">
              {!isEmpty(contentArray) && <p className="mt-1">{contentArray[0].title}</p>}
            </CCol>
          </CRow>
          <CRow className="mt-3">
            <CCol lg="4">
              <CFormCheck
                type="radio"
                name="flexRadioDefault"
                label="Banner redirect to URL"
                checked={typeBanner === 'EXTERNAL_URL'}
                onClick={() => {
                  setTypeBanner('EXTERNAL_URL')
                  setContentId('')
                  setContentArray([])
                }}
              />
            </CCol>
            <CCol>
              <CFormInput
                type="text"
                value={redirectURL}
                name="redirectURL"
                onChange={(e) => setRedirectURL(e.target.value)}
              />
              <div className="message-text error-message">
                <p>{errorData.redirectURL}</p>
              </div>
            </CCol>
          </CRow>
        </CModalBody>
        <CModalFooter>
          <CButton className="text-white" color="info" onClick={onCancel}>
            Cancel
          </CButton>
          <CButton className="text-white" color="info" onClick={handleSubmit}>
            Submit
          </CButton>
        </CModalFooter>
      </CModal>
      {imageCropObj.src && (
        <ImageCropper
          openModal={imageCropModal}
          imageCropObj={imageCropObj}
          closeModalHandle={() => {
            setImageCropModal(false)
            setImageCropObj({})
          }}
          handleCallback={handleCallback}
        />
      )}
      {showAssetManager && (
        <AssetManager showModal={setShowAssetManager} type="image" setAsset={handleAssetSelect} />
      )}
    </>
  )
}

export default BannerModal
